import React from 'react';
import styles from './Modal.module.scss';

const ModalDivider = () => {
  return <div className={`block-divider ${styles.divider}`} />;
};

export default ModalDivider;
